export const SEARCHMODE = {
  MANUAL    : 'manual',
  POSTAL    : 'postal',
  GEO       : 'geo',
  CLIENTINFO: 'details',
}

export { initPostalCodeForm }   from './postal-code-form.mjs';
export { initPersonalInfoForm } from './personal-info-form.mjs';
